var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E73A4",
    d: "M7.25.74C3.528.74.495 3.773.495 7.495S3.528 14.25 7.25 14.25s6.755-3.033 6.755-6.755S10.972.74 7.25.74m-.507 4.053a.51.51 0 0 1 .507-.506.51.51 0 0 1 .507.506v3.378a.51.51 0 0 1-.507.506.51.51 0 0 1-.507-.506zm1.128 5.66a.7.7 0 0 1-.141.224.8.8 0 0 1-.223.142.7.7 0 0 1-.257.054.7.7 0 0 1-.257-.054.8.8 0 0 1-.223-.142.7.7 0 0 1-.141-.223.7.7 0 0 1-.054-.257q.002-.134.054-.257a.8.8 0 0 1 .141-.223.8.8 0 0 1 .223-.141.68.68 0 0 1 .514 0 .8.8 0 0 1 .223.141.8.8 0 0 1 .141.223.7.7 0 0 1 .054.257q-.002.134-.054.257"
  })));
};
export default SvgInfo;